import React, { FunctionComponent } from 'react';
import { kebabCase } from 'lodash';
import { Card, ScreenReaderText } from '@mlc/web-ui-toolkit';

type Props = {
	title: string;
	children: JSX.Element | JSX.Element[];
};

const Tab: FunctionComponent<Props> = ({ title, children }) => {
	return (
		<Card
			paddingTop={3}
			paddingBottom={3}
			margin={3}
			data-id={kebabCase(title)}
		>
			<ScreenReaderText el="h4">{title}</ScreenReaderText>
			{children}
		</Card>
	);
};

export default Tab;
